import contentStateToString from './content-state-to-string';

export function getEntityCharCount(entity = {}) {
  const plainText = entity && contentStateToString(entity.content);
  return plainText ? plainText.length : 0;
}

export const isPostSeen = post => post.isSeen && post.unseenCommentsCount === 0;
